import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5569746e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cook" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "OCCUPATIONAL TRAINEESHIP FOR COOKS", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { inject, onBeforeMount, ref, reactive } from 'vue'
    import PageHeader from '@/components/PageHeader.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CookView',
  setup(__props) {

    const $axios : any = inject('axios');

    const table = ref([]);

    // onBeforeMount(() => {
    //   $axios.get('/courses/all').then((res: any) => {
    //     table.value = res.data;
    //   })
    // });

    const img = [
      {
        title:'Upcoming FREE Information Seminars in the Philippines',
        data:[
          {
            desc:'Baguio City&nbsp&nbsp&nbsp16 January 2024',
            src:'All - FLYER HOSPITALITY. BAGUIO.png'
          },
          {
            desc:'Zamboangs City&nbsp&nbsp&nbsp20 January 2024',
            src:'All - FLYER HOSPITALITY. ZAMB.png'
          }
        ]
      }
    ];

    const paragraph = [
      {
        title:'Introduction',
        data:'This Traineeship Program is sponsored by Complete Hospitality Training CHT).  This traineeship will provide participants the experience to work within the Australian hospitality industry, mainly as Cooks.<br><br>Complete Hospitality Training has designed a Job Ready Program for participants before embarking into a hands-on traineeship with various employers.<br><br>GEP GROUP partners with CHT in bringing this program to Bachelor Graduates in Hospitality or Culinary in their respective countries.'
      }
    ];

    const data = reactive(
      {
        paragraph:paragraph,
        table:table,
        img:img,
        rootPath:'/training',
        root:'Training',
        current:'cook training',
        currentPath:'/cook',
        inquiryPath:'/contact/training',
        isPara:true,
        isTable:true,
        isCarousel:true
      }
    );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(PageHeader, { value: data }, null, 8, ["value"]),
    _hoisted_3
  ]))
}
}

})